import { css } from '@linaria/atomic';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const modalFooter = css`
  display: grid;
  gap: ${theme.spacing(2)};
  align-items: center;
  grid-row-start: footer-start;
  grid-row-end: footer-end;
  padding: ${theme.spacing(0, 3)};
`;

export const modalFooterLayout = css`
  @media (min-width: ${breakpoints.xsmall.max}px) {
    // Tertiary only
    &:has(.wv-modal-footer-tertiary-button):not(
        :has(.wv-modal-footer-helper-text, .wv-modal-footer-secondary-button, .wv-modal-footer-primary-button)
      ) {
      grid-template-areas: 'tertiary';
    }

    // Secondary only
    &:has(.wv-modal-footer-secondary-button):not(
        :has(.wv-modal-footer-tertiary-button, .wv-modal-footer-helper-text, .wv-modal-footer-primary-button)
      ) {
      grid-template-areas: 'secondary';
      justify-content: end;
    }

    // Primary only
    &:has(.wv-modal-footer-primary-button):not(
        :has(.wv-modal-footer-tertiary-button, .wv-modal-footer-helper-text, .wv-modal-footer-secondary-button)
      ) {
      grid-template-areas: 'primary';
      justify-content: end;
    }

    // Primary and tertiary
    &:has(.wv-modal-footer-tertiary-button + .wv-modal-footer-primary-button):not(
        :has(.wv-modal-footer-helper-text, .wv-modal-footer-secondary-button)
      ) {
      grid-template-areas: 'tertiary secondary primary';
      grid-template-columns: auto max-content max-content;
    }

    // Primary and secondary
    &:has(.wv-modal-footer-secondary-button + .wv-modal-footer-primary-button):not(
        :has(.wv-modal-footer-tertiary-button, .wv-modal-footer-helper-text)
      ) {
      grid-template-areas: 'secondary primary';
      grid-template-columns: max-content max-content;
      justify-content: end;
    }

    // Secondary and tertiary
    &:has(.wv-modal-footer-tertiary-button + .wv-modal-footer-secondary-button):not(
        :has(.wv-modal-footer-helper-text, .wv-modal-footer-primary-button)
      ) {
      grid-template-areas: 'tertiary secondary';
      grid-template-columns: auto max-content;
    }

    // Primary, secondary and helper
    &:has(.wv-modal-footer-helper-text + .wv-modal-footer-secondary-button + .wv-modal-footer-primary-button):not(
        :has(.wv-modal-footer-tertiary-button)
      ) {
      grid-template-areas: 'helper secondary primary';
      grid-template-columns: 1fr max-content max-content;
      justify-content: end;
    }

    // Primary and helper
    &:has(.wv-modal-footer-helper-text + .wv-modal-footer-primary-button):not(
        :has(.wv-modal-footer-tertiary-button, .wv-modal-footer-secondary-button)
      ) {
      grid-template-areas: 'helper primary';
      grid-template-columns: 1fr max-content;
    }

    // Primary, secondary and tertiary
    &:has(.wv-modal-footer-tertiary-button + .wv-modal-footer-secondary-button + .wv-modal-footer-primary-button) {
      grid-template-areas: 'tertiary helper secondary primary';
      grid-template-columns: auto 1fr max-content max-content;
    }

    // Primary, secondary, tertiary and helper
    &:has(
        .wv-modal-footer-tertiary-button
          + .wv-modal-footer-helper-text
          + .wv-modal-footer-secondary-button
          + .wv-modal-footer-primary-button
      ) {
      grid-template-areas: 'tertiary helper secondary primary';
      grid-template-columns: auto 1fr max-content max-content;
    }
  }

  @media (max-width: ${breakpoints.xsmall.max}px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'helper'
      'primary'
      'secondary'
      'tertiary';
    justify-content: stretch;

    .wv-modal-footer-primary-button,
    .wv-modal-footer-secondary-button,
    .wv-modal-footer-tertiary-button.wv-button {
      width: 100%;
      overflow: hidden;
    }

    .wv-modal-footer-tertiary-button.wv-text-link {
      justify-content: center;
    }

    .wv-modal-footer-helper-text {
      text-align: center;
      margin-bottom: ${theme.spacing(1)};
    }
  }
`;

export const modalFooterTruncate = css`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const modalFooterTertiaryTextLink = css`
  width: auto;
  grid-area: tertiary;
`;

export const modalFooterTertiaryButton = css`
  grid-area: tertiary;
  width: fit-content;
`;

export const modalFooterHelperText = css`
  grid-area: helper;
  width: 100%;
  text-align: end;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const modalFooterSecondaryButton = css`
  grid-area: secondary;
  width: fit-content;
`;

export const modalFooterPrimaryButton = css`
  grid-area: primary;
  width: fit-content;
`;

export const stickyModalFooter = css`
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow: 0px -1px 3px 0px #0021521a;
  width: 100%;
  background: ${theme.colors.white};
  padding: ${theme.spacing(2)};
`;
